<template>
  <div id="app">
    <img src="./assets/logo.png">
    <ul>
      <li><router-link :to="{name:'home'}">首页</router-link></li>
      <li><router-link :to="{name:'detail'}">详情页</router-link></li>
      <li><router-link :to="{name:'list'}">列表页</router-link></li>

    </ul>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// App.vue?4cdc09c2